import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { usePolyglot } from "src/contexts"
import { DataRecency } from "src/types"
import {
  round,
  serverInsulinToUserInsulin,
} from "src/utils"

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpInsulinOnBoard = forwardRef<HTMLDivElement, Props>(
  function PumpInsulinOnBoard(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...divProps
    } = props

    const { iob: insulinOnBoard } = pumpStatus

    const polyglot = usePolyglot()

    const insulinOnBoardString: string = useMemo(
      () => {
        if (insulinOnBoard === null || pumpStatusRecency === DataRecency.Stale) {
          return "---"
        }

        return polyglot.t(
          "unit.num_units_abbreviated",
          {
            units: round(
              serverInsulinToUserInsulin(insulinOnBoard),
              2,
            ).toLocaleString(polyglot.locale()),
          },
        )
      },
      [
        polyglot,
        insulinOnBoard,
        pumpStatusRecency,
      ],
    )

    return (
      <div
        {...divProps}
        ref={propRef}
      >
        {insulinOnBoardString}
      </div>
    )
  },
)
